import { render, staticRenderFns } from "./newDynamic.vue?vue&type=template&id=f85ac256&scoped=true"
import script from "./newDynamic.vue?vue&type=script&lang=js"
export * from "./newDynamic.vue?vue&type=script&lang=js"
import style0 from "./newDynamic.vue?vue&type=style&index=0&id=f85ac256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85ac256",
  null
  
)

export default component.exports